/* Lập phiếu báo giá nháp cho một lượt — dùng ở bước Bác sĩ khám (bác sĩ kê dịch vụ) và Phiếu báo giá chính thức */
import {
  CATALOG, DAY, QUOTE_VALID_DAYS, nextCode, quarterEnd, uid,
  type ApiSvc, type OfficialQuote, type QLine, type Visit,
} from './logic';

export const apiLine = (s: ApiSvc, qty = 1): QLine => ({ id: uid(), svcId: `api-${s.id}`, apiId: s.id, name: s.name, unit: 'lần', qty, price: s.price });

/** Ưu đãi của báo giá online lịch hẹn đặt theo → trường ưu đãi của phiếu chính thức */
export const onlinePromo = (v: Visit): Pick<OfficialQuote, 'program' | 'discount' | 'reason'> => {
  const o = v.online;
  if (!o) return { discount: 0 };
  const reason = o.discount ? `Theo báo giá online ${o.code}${o.reason ? `: ${o.reason}` : ''}` : undefined;
  return { program: o.promo, discount: o.discount ?? 0, reason };
};

/**
 * Phiếu mới: dịch vụ khách đặt trên lịch hẹn; không có thì theo báo giá online (cả thẻ liệu trình) — dòng có mã danh mục (báo giá mới)
 * giữ nguyên dịch vụ thật, dòng cũ không có mã thì khớp tên bảng giá mẫu.
 */
export function draftQuote(v: Visit, by: string, used: string[]): OfficialQuote {
  const now = Date.now();
  const base = {
    code: nextCode('BG-CT', used, now), at: now, by, vat: 0, validUntil: Math.min(now + QUOTE_VALID_DAYS * DAY, quarterEnd(now)), exam: { doctor: v.invite?.doctor },
    // Ưu đãi Telesales đã báo khách (chương trình, % giảm, lý do) giữ nguyên sang phiếu chính thức
    ...onlinePromo(v),
  };
  const cards = (v.online?.items ?? []).filter((x) => x.card).map((x): QLine => ({ id: uid(), svcId: `pkg-${x.card!.apiId ?? x.card!.code}`, name: x.name, unit: 'thẻ', qty: 1, price: x.price ?? 0, card: x.card }));
  // Lịch hẹn chỉ mang dịch vụ lẻ — thẻ liệu trình Telesales đã báo khách lấy từ báo giá online, giữ giá gói đã báo
  if (v.apptSvcs?.length) return { ...base, lines: [...v.apptSvcs.map((s) => apiLine(s, s.qty)), ...cards] };
  const cat = CATALOG[v.mang];
  const lines = (v.online?.items ?? []).map((x): QLine | undefined => {
    if (x.card) return undefined; // thẻ thêm ở cuối
    if (x.id) return apiLine({ id: x.id, name: x.name, price: x.price ?? 0, qty: 1 });
    const s = cat.find((c) => x.name.toLowerCase().includes(c.name.toLowerCase().split(' · ').pop()!.toLowerCase()));
    return s ? { id: uid(), svcId: s.id, name: s.name, unit: s.unit, qty: 1, price: s.price, core: s.core } : undefined;
  }).filter((l): l is QLine => !!l);
  // Không có dịch vụ đặt trước / báo giá online: để trống, chọn từ danh mục
  return { ...base, lines: [...lines, ...cards] };
}

/** So khớp không dấu: gõ "hifu", "cay toc" vẫn ra dịch vụ */
export const fold = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
